import { z } from 'zod';
import { bicField, ibanField, normalizeIdentifier } from '../utils/identifiers.utils.js';
export { ActionLogType, ayantDroitStatutEnum, BeneficiaryValidationStatus, convertTicketingCardToEmployee, DocumentStatus, EmailPreference, EmployeeBeneficiaryDocumentType, EmployeeBeneficiaryStatus, EmployeeBeneficiaryValidationStatus, EmployeeDocumentType, EmployeeStatus, Gender, PrestationMode, } from '@cpce/ticketing-api';
export var EmployeeUrlHash;
(function (EmployeeUrlHash) {
    EmployeeUrlHash["DocumentAlert"] = "document-alert";
    EmployeeUrlHash["Search"] = "search";
})(EmployeeUrlHash || (EmployeeUrlHash = {}));
/**
 * The subject lands both in the mail header (plain text) and in the template's <h1>, so it is
 * passed through unescaped — hence the ban on angle brackets, which would break the markup.
 * A bare `&` is invalid HTML but renders fine in every mail client, so it stays allowed.
 */
export const sendDebtRemindersSchema = z.object({
    participationIds: z.array(z.number().int().positive()).min(1, 'Au moins un dossier est requis'),
    subject: z
        .string()
        .trim()
        .min(1, "L'objet est requis")
        .max(200, "L'objet est trop long")
        .refine((value) => !/[<>]/.test(value), {
        message: "L'objet ne peut pas contenir les caractères < ou >",
    }),
    body: z.string().trim().min(1, 'Le contenu est requis').max(5000, 'Le contenu est trop long'),
});
export const DEBT_REMINDER_TOKENS = ['prénom', 'nom', 'montant'];
export const DEFAULT_DEBT_REMINDER_SUBJECT = 'Relance';
export const DEFAULT_DEBT_REMINDER_BODY = 'Bonjour [prénom] [nom],\n\nCe mail fait office de relance pour la somme de [montant] €.';
const blankToNull = (value) => value && value.trim() !== '' ? normalizeIdentifier(value) : null;
// The billetterie card carries no bank details, so they are kept on our side. A blank IBAN clears
// them.
export const employeeBankDetailsSchema = z.object({
    iban: ibanField.transform(blankToNull),
    bic: bicField.optional().transform(blankToNull),
});
